import React, { useState } from "react";
import Footer from "../../components/footer/Footer";
import Newsletter from "../../components/newsletter/Newsletter";
import {
  ApplyPageContainer,
  ApplyPageTable,
  ApplyPageTitle,
  ApplyResultCard,
  FormGroup,
  Label,
  Input,
  Textarea,
  FileInput,
  FileLabel,
  SubmitButton,
} from "./ApplyStyles";
import { useLocation } from "react-router-dom";
import { smartAPI } from "../../components/api/Smart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faSpinner,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";

function Apply() {
  const [data, setData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    motivation: "",
    cv: null,
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [cvValid, setCvValid] = useState(true); // To track CV validation state

  const location = useLocation();
  const vacancyTitle = location.state?.title || "";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setCvValid(!!file); // Validate if file is selected
    setData((prevData) => ({
      ...prevData,
      cv: file,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(""); // Clear previous message

    // Validate if file is selected if it's required
    if (!data.cv) {
      setCvValid(false); // Mark CV validation as failed
      setLoading(false);
      return;
    }

    // Prepare FormData for file upload
    const dataWithFile = new FormData();
    for (const [key, value] of Object.entries(data)) {
      dataWithFile.append(key, value);
    }

    try {
      const response = await smartAPI(dataWithFile, "POST", "apply");

      if (response.status === 200) {
        setMessage("Sollicitatie succesvol verzonden.");
        setData({
          firstName: "",
          lastName: "",
          email: "",
          motivation: "",
          cv: null,
        });
      } else {
        setMessage("Er is iets misgegaan, probeer het opnieuw.");
      }
    } catch (error) {
      setMessage("Fout bij het verzenden, probeer later opnieuw.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <ApplyPageContainer>
      <ApplyPageTable>
        <ApplyPageTitle>Direct aanmelden</ApplyPageTitle>
        <ApplyResultCard>
          <form onSubmit={handleSubmit}>
            {vacancyTitle && (
              <FormGroup>
                <Label htmlFor="vacancyTitle">Vacature</Label>
                <Input
                  type="text"
                  id="vacancyTitle"
                  name="vacancyTitle"
                  value={vacancyTitle}
                  readOnly
                  disabled
                />
              </FormGroup>
            )}

            <FormGroup>
              <Label htmlFor="firstName">Voornaam *</Label>
              <Input
                type="text"
                id="firstName"
                name="firstName"
                value={data.firstName}
                onChange={handleChange}
                placeholder="Voornaam"
                required
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor="lastName">Achternaam *</Label>
              <Input
                type="text"
                id="lastName"
                name="lastName"
                value={data.lastName}
                onChange={handleChange}
                placeholder="Achtermaam"
                required
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor="email">Emailadres *</Label>
              <Input
                type="email"
                id="email"
                name="email"
                value={data.email}
                onChange={handleChange}
                placeholder="Emailadres"
                required
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor="motivation">Motivatie / Toelichting</Label>
              <Textarea
                id="motivation"
                name="motivation"
                value={data.motivation}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor="cv">Upload je CV *</Label>
              <FileInput
                type="file"
                id="cv"
                name="cv"
                onChange={handleFileChange}
                aria-invalid={!cvValid}
              />
              {!cvValid && (
                <span style={{ color: "red" }}>
                  <FontAwesomeIcon
                    icon={faWarning}
                    style={{ marginRight: "15px" }}
                  />
                  Dit veld is verplicht
                </span>
              )}
              <FileLabel htmlFor="cv">
                {data.cv ? data.cv.name : "Kies een bestand"}
              </FileLabel>
            </FormGroup>

            {/* Only show the submit button if the success message isn't set */}
            {!message.includes("succesvol") && (
              <SubmitButton type="submit" disabled={loading}>
                {loading ? (
                  <FontAwesomeIcon icon={faSpinner} spin />
                ) : (
                  "Verstuur sollicitatie"
                )}
              </SubmitButton>
            )}
          </form>
          {message.includes("succesvol") ? (
            <p
              style={{
                color: "#17224d",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              <FontAwesomeIcon
                icon={faCheck}
                style={{ color: "green", marginRight: "15px" }}
              />
              {message}
            </p>
          ) : (
            <>
              {message && (
                <p
                  style={{
                    marginTop: "20px",
                    color: "#17224d",
                    fontSize: "14px",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faWarning}
                    style={{ marginRight: "15px" }}
                  />{" "}
                  {message}
                </p>
              )}
            </>
          )}
        </ApplyResultCard>
      </ApplyPageTable>

      {/* Apply: Newsletter */}
      <Newsletter />

      {/* Apply: Footer */}
      <Footer />
    </ApplyPageContainer>
  );
}

export default Apply;
